import { Address } from '@models/address';
import { GoogleMapResult } from '@models/google-location';
import { PolicyCar } from '@models/policy-car';

export interface RoadAssistanceContextState {
  progressBarPercentageDecimal: number;
  policySelected: PolicyCar;
  fromPolicyDetail: boolean;
  problemSelected: RoadAssistanceProblem;
  message: RoadAssistanceMessage;
  assistanceData: RoadAssistanceData;
  assistanceAddress?: RoadAssistanceAddress;
  templateConfiguration: RoadAssistanceTemplateConfiguration;
}

export interface RoadAssistanceData {
  type?: RoadAssistanceMessageType;
  isParkedUnderground?: boolean;
  needTransportService: boolean;
  contactData?: RoadAssistanceContactData;
  numberOfOccupants?: number;
  additionalComment?: string;
}
export interface RoadAssistanceAddress {
  addressData?: Address;
  rawAddress: string;
  fullAddress: string;
  lat: string;
  lng: string;
  postalCode: string;
  googleMapResult?: GoogleMapResult;
}
export interface RoadAssistanceTemplateConfiguration {
  progressBarPercentageDecimal?: number;
  hideProgressBar?: boolean;
  hideCallButton?: boolean;
  showSendButton?: boolean;
  showAddessInput?: boolean;
  maxIssues?: boolean;
}

export interface RoadAssistanceContactData {
  name: string;
  documentNumber: string;
  phone: string;
}

export interface RoadAssistanceMessage {
  type: RoadAssistanceMessageType;
  topText: string;
  bottomText: string;
  phoneNumber?: string;
}

export interface RoadAssistanceProblem {
  icon?: string;
  label: string;
  description?: string;
  type: RoadAssistanceProblemTypesList;
  code: number;
}

export enum RoadAssistanceMessageType {
  OK = 'assets/images/road-assistance/road-assistance-success.svg',
  KO = 'assets/images/road-assistance/road-assistance-error.svg',
  WARNING = 'assets/images/road-assistance/road-assistance-alert.svg'
}

export enum RoadAssistanceUrls {
  SELECT_POLICY = 'road-assistance/select-policy',
  SELECT_PROBLEM = 'road-assistance/select-problem',
  INFO = 'road-assistance/info',
  MAP = 'road-assistance/map',
  CONTACT_DATA = 'road-assistance/confirm-contact-data',
  UNDERGROUND_PARKING = 'road-assistance/confirm-underground-parking',
  NUM_TRAVELERS = 'road-assistance/number-of-occupants',
  TRANSPORT_SERVICE = 'road-assistance/transport-service',
  EDIT_ADDRESS = 'road-assistance/edit-assistance-address',
  MESSAGE = 'road-assistance/message',
  TYPE_FAULT = 'road-assistance/type-of-fault',
  ADDITIONAL_COMMENT = 'road-assistance/additional-comment'
}

export enum RoadAssistanceValidationCodes {
  NOT_VALID_VEHICLE = 9,
  PENDING_RECEIPTS = 12,
  LIMIT_MAC = 17,
  LIMIT_CLASSIC = 18
}

export enum RoadAssistanceValidationStrings {
  NOT_VALID_VEHICLE = 'POLIZA NO VALIDA: tipo de vehículo no valido',
  PENDING_RECEIPTS = 'RECIBOS PENDIENTES',
  LIMIT_MAC = 'LIMITACIONES ASISTENCIA MAC',
  LIMIT_CLASSIC = 'LIMITACIONES ASISTENCIA CLASICOS'
}

export type RoadAssistanceProblemTypesList =
  'ACCIDENT' | 'BATTERY' | 'BREAKDOWN' | 'BLOWOUT' | 'FUEL' | 'OTHER' | 'DEFERRED' | 'OFFLINE';

export enum RoadAssistanceGeoLocationType {
  ROOFTOP = 'ROOFTOP'
}

export const RoadAssistanceProblemOptionsList: RoadAssistanceProblem[] = [
  {
    icon: 'assets/images/road-assistance/icon-road-assistance-accident.svg',
    label: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.ACCIDENT',
    type: 'ACCIDENT',
    code: 0
  },
  {
    icon: 'assets/images/road-assistance/icon-road-assistance-battery.svg',
    label: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.BATTERY',
    type: 'BATTERY',
    code: 33
  },
  {
    icon: 'assets/images/road-assistance/icon-road-assistance-breakdown.svg',
    label: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.BREAKDOWN',
    type: 'BREAKDOWN',
    code: 1
  },
  {
    icon: 'assets/images/road-assistance/icon-road-assistance-blowout.svg',
    label: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.BLOWOUT',
    type: 'BLOWOUT',
    code: 0
  },
  {
    icon: 'assets/images/road-assistance/icon-road-assistance-fuel.svg',
    label: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.FUELS',
    type: 'FUEL',
    code: 0
  },
  {
    icon: 'assets/images/road-assistance/icon-road-assistance-other.svg',
    label: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.OTHER',
    description: 'ROAD_ASSISTANCE.ROAD_ASSISTANCE_PROBLEMS.OTHER_DETAIL',
    type: 'OTHER',
    code: 0
  }
];

export const RoadAssistanceFaultsOptionsList = [
  'ROAD_ASSISTANCE.FAULT.DOESNT_START',
  'ROAD_ASSISTANCE.FAULT.IT_STOPPED',
  'ROAD_ASSISTANCE.FAULT.IT_HEATS_UP',
  'ROAD_ASSISTANCE.FAULT.MOTOR_ISSUES',
  'ROAD_ASSISTANCE.FAULT.OTHER_I_DONT_KNOW',
];

export interface RoadAssistanceOccupantsNumber {
  label: string;
  value: number;
}

export const OCCUPANTSNUMBERS: RoadAssistanceOccupantsNumber[] = [
  {
    label: '1',
    value: 1
  },
  {
    label: '2',
    value: 2
  },
  {
    label: '3',
    value: 3
  },
  {
    label: '4',
    value: 4
  },
  {
    label: '5',
    value: 5
  },
  {
    label: '5+',
    value: 6
  }
];


